// "Show Labels on Tasks" setting (localStorage), mirroring Android's
// configuration_screen_config_show_labels_on_tasks. Default ON.
export const SHOW_LABELS_KEY = "user_setting_show_labels_on_tasks";

export const isShowLabelsOnTasks = () => {
  try {
    const v = localStorage.getItem(SHOW_LABELS_KEY);
    return v === null ? true : v === "true";
  } catch (e) {
    return true;
  }
};

export const setShowLabelsOnTasks = (enabled) => {
  try {
    localStorage.setItem(SHOW_LABELS_KEY, String(enabled));
  } catch (e) {
    /* ignore */
  }
};
